export enum TrainingLearningMutationType {
    SET_LOADING = 'SET_LOADING',
    SET_TRAINING_LEARNING = 'SET_TRAINING_LEARNING',
    SET_SELECTED_TRAINING_LEARNING = 'SET_SELECTED_TRAINING_LEARNING',
    SET_SEARCH_TRAINING = 'SET_SEARCH_TRAINING',
  }
